const R = require('ramda')

// const installData = require('./data/installClient')
const installView = require('./view/installClient')

module.exports = R.pipe(
  // installData,
  installView,
)
